
    import '/Users/lijixiang/Work/power-design/site/docs/power-design/service-tool.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-power-design-service-tool-demo-basic","docs-power-design-service-tool-demo-config","docs-power-design-service-tool-demo-style"],
  getter: () => import(/* webpackChunkName: "meta__docs" */'/Users/lijixiang/Work/power-design/site/docs/power-design/service-tool.md?type=demo')
};